import React from "react";
import { feathersApp } from "../config/feathers";
import { setcategories } from "../actions/categories";
import { libTypes } from "@holta/lib";

export const useLoadcategories = () => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const hasRun = React.useRef(false);
    if (!hasRun.current) {
        feathersApp
            .service("categories")
            .watch()
            .find({
                query: {
                    $limit: 100000,
                },
            })
            .subscribe(({ data }: { data: libTypes.Category[] }) => {
                setcategories(data.sort((a, b) => b.name.localeCompare(a.name)));
                setIsLoaded(true);
            });
        hasRun.current = true;
    }
    return isLoaded;
};
